import React, { useState, useEffect } from 'react';
import { WifiOff } from 'lucide-react';

const OfflineIndicator = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div
      data-testid="offline-indicator"
      className="fixed top-0 left-0 right-0 z-[100] bg-yellow-600/90 text-black text-center py-1.5 text-xs font-bold backdrop-blur-sm"
    >
      <WifiOff className="w-3.5 h-3.5 inline mr-1.5 -mt-0.5" />
      Offline-Modus - Gecachte Daten werden angezeigt
    </div>
  );
};

export default OfflineIndicator;
